<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  <mat-label>{{ data.label }}</mat-label>
</div>
<div mat-dialog-actions>
  <button [mat-dialog-close]="true" class="button-save">
    Ok
  </button>
  <button mat-button [mat-dialog-close]="false">Cancelar</button>
</div>